import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStorefrontConfig } from '../../hooks/StorefrontSettingsContext';
import * as userActions from '../../actions/userActions';

import useUserDetails from './useUserDetails';
import UserHeader from './UserHeader';
import UserEmails from './UserEmails';
import UserRoles from './UserRoles';
import UserCustomers from './UserCustomers';
import SalesTerritorySelector from './SalesTerritorySelector';
import Loading from '../Loading';
import MessageStandard from '../MessageStandard';
import UserIcon from '../icons/User';
import Authorize from '../Authorize';

const Details = ({
    userId,
    usersToClone,
    currentUser,
    userActions,
    refreshFilteredUsers,
    StorefrontConfig,
    setSelectedStorefront,
    userSettings
}) => {
    const {
        user,
        loading,
        modals,
        persona,
        storefront,
        branches,
        handlers,
        localized,
        salesTerritorySelector
    } = useUserDetails({
        userId,
        currentUser,
        usersToClone,
        userActions,
        refreshFilteredUsers,
        StorefrontConfig,
        setSelectedStorefront,
        userSettings
    });

    if (loading) return <Loading type="brand" />;

    if (!user) {
        return (
            <div className="fele-select-user-message">
                <MessageStandard icon={<UserIcon />} line1={localized.UserInstructionsMessage} />
            </div>
        );
    }

    return (
        <div className="fele-user-details active">
           <UserHeader
                user={user}
                persona={persona}
                storefront={storefront}
                onToggleActive={handlers.toggleIsActive}
                onEditName={handlers.updateFullNameState}
                localized={localized}
                userActions={userActions}
                isAdmin={currentUser?.roles?.includes('Administrator')}
            />

            <UserEmails
                user={user}
                secondaryEmail={handlers.secondaryEmail}
                onOpenModal={handlers.openSecondaryEmailModal}
                onCloseModal={handlers.closeSecondaryEmailModal}
                onRemove={handlers.removeSecondaryEmail}
                modals={modals}
                onSave={handlers.saveSecondaryEmail}
                onChange={handlers.updateSecondaryEmail}
                isValid={handlers.isValidEmail}
                localized={localized}
            />

            <UserRoles
                user={user}
                persona={persona}
                storefront={storefront}
                modals={modals}
                handlers={handlers}
                localized={localized}
                currentUser={currentUser}
                branches={branches}
                StorefrontConfig={StorefrontConfig}
            />

            <UserCustomers user={user} currentUser={currentUser} localized={localized} />
            {salesTerritorySelector === true && (
                <Authorize as="Administrator">
                    <SalesTerritorySelector localized={localized} user={user} />
                </Authorize>
            )}
        </div>
    );
};

Details.propTypes = {
    userId: PropTypes.string.isRequired,
    usersToClone: PropTypes.array,
    currentUser: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    refreshFilteredUsers: PropTypes.func.isRequired,
    StorefrontConfig: PropTypes.object.isRequired,
    setSelectedStorefront: PropTypes.func.isRequired,
    userSettings: PropTypes.object.isRequired,
    updateBranches: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    user: state.user.selectedUser,
    filteredUsers: state.user.filteredUsers
});

const mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(userActions, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStorefrontConfig(Details));
